import styled from 'styled-components'

export const Logo = styled.div`
  align-items: center;
  color: #fff;
  font-size: 1.3em;
  margin-left:15px;
`;